import React from 'react';

const SvgComponent = props => (
  <svg
    width={166}
    height={104}
    viewBox="0 0 166 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M134.491 52.8574H113.844V71.7901H134.491V52.8574Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M147.19 37.8986H143.45V27.2246H147.346C149.527 27.2246 151.319 29.0166 151.319 31.1981V33.6913C151.397 36.0287 149.527 37.8986 147.19 37.8986Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.146 37.8986H104.886V27.2246H100.99C98.8086 27.2246 97.0166 29.0166 97.0166 31.1981V33.6913C97.0166 36.0287 98.8086 37.8986 101.146 37.8986Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.285 58.8578C113.611 58.8578 104.885 50.1317 104.885 39.4577V23.3298C104.885 19.3563 108.158 16.084 112.131 16.084H136.284C140.257 16.084 143.53 19.3563 143.53 23.3298V39.6914C143.452 50.2096 134.804 58.8578 124.285 58.8578Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M102.859 9.85091C99.9761 16.7072 101.846 22.7844 104.729 22.7844H141.27C144.152 22.7844 145.866 20.3691 146.568 17.4863C147.269 14.6815 149.295 4.31914 149.295 4.31914C149.295 4.31914 109.481 -6.0432 102.859 9.85091Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M155.762 68.752L140.257 63.7656H108.079L92.5747 68.752C87.5104 70.6219 84.1602 75.5304 84.1602 80.9063V101.787H164.176V80.9063C164.176 75.5304 160.826 70.6998 155.762 68.752Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.206 101.164L139.866 64.0781L145.788 71.8694L137.139 79.1931L142.204 85.2703L128.881 97.5804"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M122.337 96.8792L108.469 64.0781L102.625 71.8694L111.196 79.1931L106.132 85.2703L119.532 97.5804"
        fill="#fff"
      />
      <path
        d="M122.337 96.8792L108.469 64.0781L102.625 71.8694L111.196 79.1931L106.132 85.2703L119.532 97.5804"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g>
      <path
        d="M62.1032 18.6097C61.4884 20.2237 60.4892 21.5303 59.1057 22.0683C59.3363 22.8369 59.49 23.6055 59.49 24.451V28.2939H63.333C63.871 28.2939 64.409 28.4476 64.8702 28.6014C64.4859 13.9981 61.3346 11.1543 61.3346 11.1543C62.3338 13.9981 62.4875 16.6113 62.1032 18.6097Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.9473 38.4401C64.4093 38.6707 63.7944 38.8244 63.1795 38.8244H59.4903V40.5922C59.4903 51.0451 50.9589 59.4996 40.5829 59.4996C30.0532 59.4996 21.4449 50.8914 21.4449 40.3616V38.8244H17.7557C17.0639 38.8244 16.4491 38.6707 15.911 38.3633C15.2962 54.35 9.07056 56.4252 9.07056 56.4252C9.07056 56.4252 16.3722 60.9599 40.4292 59.4996C64.563 60.9599 71.7878 56.4252 71.7878 56.4252C71.7878 56.4252 65.5622 54.4269 64.9473 38.4401Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4438 28.3706V24.5276C21.4438 23.759 21.5975 23.0673 21.7512 22.3756C20.0603 21.9144 18.9074 20.5309 18.2157 18.7632C17.9083 17.1491 17.9083 15.1508 18.3694 12.9219C17.4471 15.0739 16.1405 19.6086 15.9099 28.7549C16.4479 28.5243 16.9859 28.3706 17.6008 28.3706H21.4438Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.9478 28.6785C64.4866 28.448 63.9486 28.3711 63.4106 28.3711H59.5676V38.9008H63.2569C63.8718 38.9008 64.4866 38.7471 65.0246 38.5165C66.4081 37.8248 67.3304 36.4413 67.3304 34.8273V32.3678C67.3304 30.6769 66.3312 29.2934 64.9478 28.6785Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.6022 28.3711C16.9873 28.3711 16.4493 28.5248 15.9112 28.7554C14.6046 29.3703 13.6055 30.7537 13.6055 32.2909V34.7504C13.6055 36.3645 14.5278 37.6711 15.8344 38.3628C16.3724 38.6702 17.0641 38.824 17.679 38.824H21.3683V28.3711H17.6022Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5054 59.5776C36.7393 59.5776 33.2038 58.5016 30.2063 56.5801V72.4131H50.574V56.6569C47.7302 58.5016 44.2716 59.5776 40.5054 59.5776Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.0293 22.1465C58.4913 22.3771 57.8764 22.5308 57.2615 22.5308H22.5211C22.2137 22.5308 21.9831 22.4539 21.7525 22.3771C21.5219 23.0688 21.4451 23.7605 21.4451 24.5291V28.3721V38.9018V40.439C21.4451 47.2026 24.9806 53.1208 30.2839 56.5026C33.2814 58.4241 36.8169 59.5001 40.583 59.5001C44.2723 59.5001 47.731 58.4241 50.6516 56.5795C55.9549 53.2745 59.4904 47.3563 59.4904 40.5927V38.825V28.3721V24.5291C59.4904 23.6837 59.3367 22.8382 59.0293 22.1465Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4451 28.3711V38.9008V28.3711Z"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M61.4137 11.2316C61.2599 10.7705 61.1062 10.2325 60.8756 9.77132C57.8781 2.54654 48.117 0.855637 38.3559 1.00936C29.8245 1.31679 22.0617 3.46885 19.3716 9.69446C18.9104 10.7705 18.603 11.8465 18.3724 12.9226C17.9113 15.1515 17.8344 17.1498 18.2187 18.7639C18.9104 20.5316 20.0633 21.9151 21.7542 22.3762C21.9848 22.4531 22.2923 22.53 22.5228 22.53H57.2633C57.955 22.53 58.493 22.3762 59.031 22.1457C60.4145 21.5308 61.4137 20.2242 62.0285 18.687C62.4897 16.6118 62.336 13.9986 61.4137 11.2316Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M71.6337 69.337L56.3387 64.418H24.5958L9.30081 69.337C4.30495 71.2585 1 76.0237 1 81.327V102.07H79.9345V81.327C79.9345 76.0237 76.6296 71.2585 71.6337 69.337Z"
        fill="#fff"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.4285 101.312L55.9541 64.7266L61.7185 72.4125L53.264 79.6373L58.2598 85.6323L45.04 97.7761"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6602 97.0843L24.9792 64.7266L19.1379 72.4125L27.6693 79.6373L22.6735 85.6323L35.8164 97.7761"
        fill="#fff"
      />
      <path
        d="M38.6602 97.0843L24.9792 64.7266L19.1379 72.4125L27.6693 79.6373L22.6735 85.6323L35.8164 97.7761"
        stroke="#2F6ECD"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgComponent;
